import { Swiper, Navigation, Pagination } from 'swiper';

const FeaturedProductCarousel = function () {
  const containers = document.querySelectorAll(
    '.featured-product-carousel',
  );
  Swiper.use([Navigation, Pagination]);
  containers.forEach(function (container) {
    const tabs = container.querySelectorAll('.product-carousel__tabs a');
    const swiperContainer = container.querySelector('.swiper');
    let btnNext = container.querySelector('.swiper-button-next');
    let btnPrev = container.querySelector('.swiper-button-prev');
    if( tabs ){
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          tabs.forEach((tab) => tab.classList.remove('active'));
          tab.classList.add('active');
          swiper.slideTo(index);
        });
      });
    }
    const swiper = new Swiper(swiperContainer, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: {
        768: {
          spaceBetween: 120,
        }
      },
      on: {
        slideChange: function () {
          tabs.forEach((tab) => tab.classList.remove('active'));
          tabs[swiper.activeIndex].classList.add('active');
        },
      }
    });
  });
};

export default FeaturedProductCarousel;
